import { useState } from "react";
import { useAxios } from "../../../utils/useAxios";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";

/**
 * @typedef {import("./useCreateLesson").LessonCreateDataType} LessonCreateDataType
 */

/**
 * Update Data Props Type
 * @typedef {Object} UpdateDataProps
 * @property {number} lessonId
 * @property {LessonCreateDataType} lessonData
 */

/**
 * Custom hook to update a lesson detail , which take lessonId and  LessonCreateDataType as parameter
 */
export const useUpdateLesson = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [lessonDetail, setLessonDetail] = useState(
    /** @type {LessonCreateDataType | null | undefined} */ (undefined),
  );
  const { axiosInstance } = useAxios();
  /**
   * @param {UpdateDataProps} params
   */
  const updateLesson = async ({ lessonId, lessonData }) => {
    setLoading(true);
    setError("");
    try {
      const response = await axiosInstance.put(
        `${TENANT_DOMAIN}/lesson/update/${lessonId}`,
        lessonData,
      );
      setLessonDetail(response.data?.data);
      return response.data?.data || null;
    } catch (error) {
      setLessonDetail(null);
      if (error.response.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(error.response.data.message || ERROR_MESSAGES.UNKNOWN);
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    lessonDetail,
    loading,
    error,
    updateLesson,
  };
};
